import { render } from "./ColumnsVideoPlay.vue?vue&type=template&id=618bcfe0&scoped=true"
import script from "./ColumnsVideoPlay.vue?vue&type=script&lang=js"
export * from "./ColumnsVideoPlay.vue?vue&type=script&lang=js"

import "./ColumnsVideoPlay.vue?vue&type=style&index=0&id=618bcfe0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-618bcfe0"

export default script